import { useMemo } from 'preact/hooks'
import { useFilters } from 'libs/searchspring/hooks/useFilters'
import { ColorSwatch, getFilterDisplayCustomisations, IconImage } from 'libs/searchspring/components/collection/filters/FilterCustomisations'
import clsx from 'clsx'
import { RANGE_INDICATOR } from './FilterUtils'

export function CustomFilter({ filter }) {
  if (!filter) return null
  const {
    handleToggleFilter,
    activeFilters,
    fetchedFilters
  } = useFilters()

  const fetchedFilter = useMemo(() => {
    return fetchedFilters.find((current) => current.field === filter)
  }, [fetchedFilters])

  if (!fetchedFilter) return null

  const filterCustomizations = useMemo(() => {
    return getFilterDisplayCustomisations(filter)
  }, [filter])

  const values = useMemo(() => {
    return (
      fetchedFilter.values.map((item) => {
        const value = item.type === 'range' ? `${item.low}${RANGE_INDICATOR}${item.high}` : item.value
        const valueWithKey = `${fetchedFilter.field}:${value}`

        const fetchedValue = fetchedFilter?.values?.find((currentValue) => {
          return currentValue.label === item.label
        })
        const customValue = filterCustomizations.values?.find(
          (customItem) => customItem.value === item.label
        ) || {}

        const {
          icon = false,
          icon_id: iconID = false,
          icon_aspect_ratio: aspectRatio = false,
          icon_width: iconWidth = false,
          filter_colour: filterColour = false
        } = customValue

        return {
          label: item.label,
          value: valueWithKey,
          count: fetchedValue?.count,
          checked: activeFilters?.has(valueWithKey),
          disabled: !fetchedValue,
          color: filterColour,
          icon: (icon && iconID && aspectRatio) ? { icon, iconID, aspectRatio, iconWidth } : false
        }
      }) ?? []
    )
  }, [activeFilters, fetchedFilter])

  if (!values.length === 0) return null

  return (
    <div className="flex flex-col gap-4 p-4 md:flex-row md:justify-between md:items-center md:p-6">
        <p className="paragraph-md">Shop by {fetchedFilter.label}</p>
        <div className="flex max-w-full gap-2 overflow-x-auto grow md:justify-end">
            {values.map((item) => {
              return (
                <div className="flex items-center" key={item.value}>
                    <input
                    id={item.value}
                    type="checkbox"
                    name={filter.field}
                    checked={item.checked}
                    disabled={item.disabled}
                    onClick={() => handleToggleFilter(item.value)}
                    className="hidden field-checkbox peer"
                    />
                    <label
                for={item.value}
                className={clsx('flex items-center gap-2 paragraph-md peer-disabled:text-neutral-medium btn btn-primary-outline peer-checked:btn-primary btn-lg !border-neutral-tertiary hover:!border-brand-black', item.icon && 'flex-col')}
              >
                {item.color && <ColorSwatch color={item.color} />}
                {item.icon && <IconImage iconObject={item.icon} />}
                <div className={'inline-block'}>
                {item.label}
                {!item.count ? null : (
                  <span className="paragraph-md text-neutral-secondary">
                    &nbsp;({item.count})
                  </span>
                )}
                </div>
              </label>
                </div>
              )
            })}
        </div>
    </div>

  )
}
